/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var UIUtil = require('psa-core/util/ui');

var ConfirmationModalView = require('common/views/ConfirmationModalView');
var DropdownView = require('common/views/DropdownView');
var BreadcrumbView = require('common/views/BreadcrumbView');

var SubmitEntityTracking = require('../services/SubmitEntityTracking');

var tmplDepKeyThirdPartyVendorDashboardView = require('../templates/DepKeyThirdPartyVendorDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepKeyThirdPartyVendorDashboardView,

  className: 'dep-key-third-party-vendor-dashboard-view container-fluid',

  ui: {
    headerBar: '.header-bar-container',
    breadcrumb: '.breadcrumb-container',
    actionDropdown: '.dropdown-container'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    actionDropdown: '@ui.actionDropdown'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');

    var entityName = this.model.get('entityName');
    var tracking = this.model.get('entityTracking') || {};
    var vendorName = tracking.vendorName || '';

    this.showChildView(
      'actionDropdown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Key Third-Party Vendor Actions',
          options: [
            {
              text: 'Edit Key Third-Party Vendor',
              link: '#dep/entity/' + entityId + '/key-third-party-vendor/' + tracking.id + '/edit'
            },
            {
              text: 'Delete Key Third-Party Vendor',
              onClick: this.onClickDelete.bind(this)
            }
          ]
        })
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: vendorName + ' (' + tracking.enteredDate + ')'
          }
        ]
      })
    );
  },

  onClickDelete: function(e) {
    e.preventDefault();

    var tracking = this.model.get('entityTracking') || {};
    var entityId = this.model.get('entityId');
    UIUtil.showModal({
      title: 'Confirm Deleting Key Third-Party Vendor',
      view: new ConfirmationModalView({
        confirmText: 'Delete Key Third-Party Vendor',
        model: new Backbone.Model({
          message: 'Are you sure you want to delete this key third-party vendor?',
          onConfirm: function() {
            return SubmitEntityTracking({
              id: tracking.id,
              shouldDelete: '1'
            });
          },
          onConfirmDone: function() {
            Radio.channel('navigate').trigger('show:int:dp:entity', entityId);
          }
        })
      })
    });
  }
});
